import { useState, ReactNode } from 'react';
import Sidebar from '@/components/feature/Sidebar';
import TopBar from '@/components/feature/TopBar';

interface AppShellProps {
  pageTitle: string;
  pageSubtitle?: string;
  breadcrumbs?: { label: string; path?: string }[];
  children: ReactNode;
  notifications?: {
    id: string;
    title: string;
    description: string;
    time: string;
    read: boolean;
    type: 'info' | 'warning' | 'success' | 'error';
  }[];
}

export default function AppShell({
  pageTitle,
  pageSubtitle,
  breadcrumbs,
  children,
  notifications = [],
}: AppShellProps) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="flex h-screen bg-background-100 overflow-hidden">
      {/* Sidebar */}
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />

      {/* Main area */}
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
        <TopBar
          pageTitle={pageTitle}
          pageSubtitle={pageSubtitle}
          breadcrumbs={breadcrumbs}
          notifications={notifications}
        />

        {/* Page content */}
        <main
          id="main-content"
          className="flex-1 overflow-y-auto p-4 md:p-6 page-enter"
        >
          {children}
        </main>
      </div>
    </div>
  );
}